import { TextField } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

import type { Answer } from "../answers";

type Props = { answer: Answer | undefined; onChange: (answer: Answer) => void; error: boolean };

export const OtherField: React.FC<Props> = ({ answer, onChange, error }) => {
    const { formatMessage } = useIntl();
    return (
        <TextField
            autoFocus
            size="small"
            value={answer?.other ?? ""}
            error={error}
            placeholder={formatMessage({ defaultMessage: "Please specify" })}
            onChange={(event) => onChange({ ...answer, other: event.target.value })}
            sx={{ maxWidth: 360, ml: 4 }}
        />
    );
};
